import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { Paper, Container, Grid, Typography, Link, Divider, makeStyles }
    from '@material-ui/core';

import Logo from '../../images/logo.svg';

const useStyles = makeStyles((theme) => ({
    footer: props => ({
        backgroundColor: props.prefersDarkMode ? theme.palette.background.paper
            : theme.palette.primary.main,
        marginTop: theme.spacing(8)
    }),
    container: {
        padding: theme.spacing(4)
    },
    divider: {
        margin: theme.spacing(1, 0, 1, 0),
        backgroundColor: 'rgba(255, 255, 255, 0.12)'
    },
    text: {
        color: theme.palette.primary.contrastText
    },
    logo: {
        width: theme.spacing(8),
        height: theme.spacing(8),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(2)
    }
}));

export default function Footer(props) {
    const classes = useStyles(props);

    return (
        <Paper component="footer" className={classes.footer}>
            <Container maxWidth="lg" className={classes.container}>
                <Grid container direction="column" justifyContent="center" alignItems="center" spacing={2}>
                    <Grid item>
                        {props.darkModeFormGroup}
                    </Grid>
                    <Grid item>
                        {props.unitSelect}
                    </Grid>
                    <Grid item>
                        <img src={Logo} alt="Snotel" className={classes.logo} />
                    </Grid>
                </Grid>
                <Divider className={classes.divider} />
                <Grid container alignItems="center" justifyContent="space-evenly" spacing={2}>
                    {[
                        { title: 'About', to: '/about' }, { title: 'Contact', to: '/contact' }
                    ].map((link) => (
                        <Grid item key={link.title}>
                            <Link
                                variant="caption" className={classes.text}
                                to={link.to} component={RouterLink}
                            >
                                {link.title}
                            </Link>
                        </Grid>
                    ))}
                    <Grid item>
                        <Typography variant="caption" className={classes.text}>
                            <Link
                                href="https://github.com/jackv545/Snotel-UI"
                                target="_blank" rel="noopener" color="inherit"
                            >
                                GitHub Project
                            </Link>
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="caption" className={classes.text}>
                            © {new Date().getFullYear()} <Link
                                href="https://jackvisser.com" color="inherit"
                            >
                                Jack Visser
                            </Link>
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
        </Paper>
    );
}
